/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum NextStep {
	AuthStart = 'AuthStart',
	DeviceVerification = 'DeviceVerification',
	PasswordLogin = 'PasswordLogin',
	MultifactorLogin = 'MultifactorLogin',
	TermsOfService = 'TermsOfService',
	LockedAccount = 'LockedAccount',
	MultifactorSetup = 'MultifactorSetup',
	ResetPassword = 'ResetPassword',
	Success = 'Success',
	Signup = 'Signup',
	AccessLost = 'AccessLost',
}
